import { useState } from 'react';
import VerificationEmail from './VerificationEmail';
import VerificationCode from './VerificationCode';
import NewPassword from './NewPassword';

const ForgotPassword = () => {
  const [step, setStep] = useState<'email' | 'otp' | 'newPassword'>('email');
  const [data, setData] = useState<{ email?: string; code?: string }>({});

  const getUICurrent = () => {
    switch (step) {
      case 'email':
        return <VerificationEmail setStep={setStep} setData={setData} />;
      case 'otp':
        return (
          <VerificationCode data={data} setData={setData} setStep={setStep} />
        );
      default:
        return <NewPassword data={data} />;
    }
  };

  return getUICurrent();
};

export default ForgotPassword;
